import { Button, Container, Dialog, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { AsyncWrapper } from "../async";
import { loadCurrentZone, refreshCurrentZone } from "./trackerSlice";
import { VouchForm } from "./vouchForm";

import './tracker.css'
import { ZoneList } from "./zoneList";
import { useParams } from "react-router-dom";

const REFRESH_TIME_SECONDS = 60;
const DEFAULT_LADDER = 'ladder';

export const CurrentZoneDisplay = () => {
  const { ladder } = useParams();
  console.log(ladder);
  const [showForm, setShowForm] = useState(false);
  const { currentZone, currentZoneLoadStatus } = useAppSelector(state => state.tracker);
  const dispatch = useAppDispatch();
  useEffect(() => {
    console.log('Setting up refresh callback')
    const refreshInterval = setInterval(() => {
      dispatch(refreshCurrentZone(ladder || DEFAULT_LADDER))
    }, REFRESH_TIME_SECONDS * 1000);

    return () => {
      console.log('Cleaning up refresh callback')
      clearInterval(refreshInterval);
    }
  })
  return <Container>
    <AsyncWrapper
        status={currentZoneLoadStatus}
        shouldInitialize={true}
        asyncAction={() => {
          dispatch(loadCurrentZone(ladder || DEFAULT_LADDER));
        }}>
      <>
        <Stack spacing={1}>
          {currentZone.candidates.length ? 
            <ZoneList zones={currentZone.candidates} />
          :
            <p>
              Nobody has vouched which zone is terrorized yet this hour. Be the first one to vouch!
            </p>
          }
          <Button variant='outlined' onClick={() => setShowForm(true)}>
            {'Vouch for a zone'}
          </Button>
        </Stack>
        <Dialog
            open={showForm}
            onClose={() => setShowForm(false)}
            maxWidth='lg'
            fullWidth={true}>
          <VouchForm closeForm={() => setShowForm(false)}/>
        </Dialog>
      </>
    </AsyncWrapper>
  </Container>
}

